import { CarrierModule } from 'enums';
import { FormFieldsConfigProps } from 'hooks';

export interface CarrierDialogLocationState {
  scrollTo?: CarrierFormFieldsNames;
}

export interface CarrierFormDataProps {
  name: string;
  domain: string[];
  purchasedModules: CarrierModule[];
  stpConfidenceThreshold: number | null;
}

export enum CarrierFormFieldsNames {
  Name = 'name',
  Domain = 'domain',
  PurchasedModules = 'purchasedModules',
  StpConfidenceThreshold = 'stpConfidenceThreshold',
}

export type FormFieldsConfig = Record<CarrierFormFieldsNames, FormFieldsConfigProps<CarrierFormFieldsNames>>;
